import { AxiosInstance } from 'axios';

import { insertId } from '../../insertId';
import { IProfile } from 'src/views/Admin/Profiles/types';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  profile: IProfile
) => {
  const urlWithId = insertId(url, profile.id);
  const response = await api.put(urlWithId, profile);
  return toResponse(response.data) as IProfile;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/profiles/update.ts